<template>
  <div class="nav">
    <div
      class="nav-top"
      :style="{
        backgroundColor: color,
        color: color == '#ffffff' ? '#000' : '#fff',
      }"
    >
      <div class="back" @click="back" v-if="routePages > 1">
        <img
          :src="
            color == '#ffffff'
              ? '../../../static/black_return.png'
              : '../../../static/back.png'
          "
          alt=""
        />
      </div>

      <span>{{ title }}</span>
      <div class="nav-top-right">
        <img
          @click="changeStatus"
          v-if="!isDetail"
          class="icon_more"
          :src="
            isRoute
              ? '../../static/route_close.png'
              : '../../static/more_icon.png'
          "
          alt=""
        />
        <img
          @click="changeStatus"
          v-else
          class="icon_more"
          :src="
            isRoute
              ? '../../static/route_closes.png'
              : '../../static/more_icons.png'
          "
          alt=""
        />
      </div>
    </div>

    <div class="route-mask" v-if="isRoute" @click="changeStatus">
      <div class="mask-content">
        <div
          class="mask-content-view"
          v-for="(item, index) in tabbar"
          :key="index"
          @click.stop="routePage(item, index)"
        >
          <img class="mask-content-img" :src="item.iconPath" alt="" />
          <span class="mask-content-text">{{ item.text }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, MessageBox } from "mint-ui";
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "#ffffff",
    },
    pagetype: {
      type: String,
      default: "",
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      routePages: 0,
      isRoute: false,
      tabbar: [
        {
          iconPath: "../../static/icon_shujia.png",
          text: "书架",
          url: "/",
        },
        {
          iconPath: "../../static/icon_shucheng.png",
          text: "书城",
          url: "/",
        },
        {
          iconPath: "../../static/icon_fuli.png",
          text: "福利",
          url: "/",
        },
        {
          iconPath: "../../static/icon_wode.png",
          text: "我的",
          url: "/",
        },
        {
          iconPath: "../../static/icon_chongzhi.png",
          text: "充值",
          url: "/pages/bookCharge/index",
        },
        {
          iconPath: "../../static/icon_short.png",
          text: "排行榜",
          url: "/pages/bookSort/index",
        },
        {
          iconPath: "../../static/icon_fenlei.png",
          text: "分类",
          url: "/pages/bookClass/index",
        },
        {
          iconPath: "../../static/icon_lastread.png",
          text: "最近阅读",
          url: "/pages/bookLastRead/index",
        },
      ],
    };
  },
  mounted() {
    this.routePages = window.history.length;
  },
  methods: {
    back() {
      console.log("test");
      if (this.title == "充值中心") {
        this.$emit("returnCharge");
        return true;
      } else if (this.title == "选择优惠券") {
        this.$emit("returnCoupon");
        return true;
      }
      console.log(this.pagetype);
      console.log(this.title);
      console.log(this.$router)
      if (this.title == "书籍详情") {
        this.$router.go(-1);
      } else {
        this.$router.back();
        //  this.$router.go(-1);
      }
    },
    changeStatus() {
      this.isRoute = !this.isRoute;
    },
    routePage(item, index) {
      if (index < 4) {
        this.$base.setStorage("tabbarIndex", index);
        this.$router.push({
          path: item.url,
        });
      } else {
        this.$router.push({
          path: item.url,
        });
      }
      this.isRoute = false;
    },
  },
};
</script>
<style scoped>
.nav-top {
  display: flex;
  height: calc(44px + env(safe-area-inset-top));
  padding: 7px 3px;
  background-color: #5f4c4c;
  position: fixed;
  top: 0px;
  width: 100%;
  box-sizing: border-box;
  z-index: 99;
  left: 0;
}
.nav-top-right {
  position: absolute;
  right: 12px;
  top: 10px;
  z-index: 999;
}
.icon_more {
  width: 16px;
  height: 16px;
  z-index: 999;
}
.route-mask {
  position: fixed;
  height: 100%;
  top: calc(44px + env(safe-area-inset-top));
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  left: 0;
  z-index: 9999;
}

.mask-content {
  background-color: #ffffff;
  overflow: hidden;
  padding-top: 25px;
}

.mask-content-view {
  float: left;
  width: 25%;
  margin-bottom: 25px;
}

.mask-content-img {
  width: 27px;
  height: 27px;
  display: block;
  margin: 0 auto;
}

.mask-content-text {
  font-size: 12px;
  color: #666666;
  display: block;
  text-align: center;
}
.nav-top > .back {
  width: 44px;
  height: 44px;
  position: absolute;
  left: 0px;
  top: 0px;
  text-align: center;
}
.nav-top > div.back > img {
  width: 9px;
  height: 16px;
  margin-top: 17px;
}
.nav-top > span {
  width: 100%;
  display: block;
  font-size: 16px;
  font-weight: 700;
  line-height: 30px;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/view/components/navbar.vue